import { Flex, Link, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { AppRoutes } from "@/constants/routes";
import { PermissionCode } from "@/constants/permissions";
import { Permiso } from "@/pages/role-asignation/schema/role-assignation.schema";

interface Props {
  permissions?: Permiso[] | null;
}

export const OnboardingView = ({ permissions }: Props) => {
  const navigate = useNavigate();

  const hasAccess = (codigo: string) =>
    permissions?.some((p) => p.codigo === codigo && p.tipoPermiso === "R");

  const canUseUsers =
    hasAccess(PermissionCode.USERS);
  const canUseContactRequests =
    hasAccess(PermissionCode.CONTACT_REQUESTS);

  return (
    <Flex flexDir="column" paddingX={2} paddingY={1} gap="10px">
      {canUseUsers && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.USERS)}>
          <Text
            fontWeight={500}
            fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
          >
            Usuarios
          </Text>
        </Link>
      )}
      {canUseContactRequests && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.CONTACT)}>
          <Text
            fontWeight={500}
            fontSize={{ base: "12px", md: "12px", "2xl": "16px" }}
          >
            Solicitudes de contacto
          </Text>
        </Link>
      )}
    </Flex>
  );
};
